import React from 'react';
import { Line } from 'react-chartjs-2';
import { formatCompactNumber } from '../utils/formatters';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const UserDownloadsChart = ({ data, viewType = 'daily', periodLabel = 'Last 7 Days', onViewChange }) => {
  const totalDownloads = data.reduce((sum, item) => sum + item.count, 0);
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const chartData = {
    labels: data.map(item => item.label || formatDate(item.date)),
    datasets: [
      {
        label: 'User Downloads',
        data: data.map(item => item.count),
        borderColor: '#3491f7',
        backgroundColor: 'rgba(52, 145, 247, 0.1)',
        borderWidth: 3,
        pointBackgroundColor: '#3491f7',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 7,
        pointHoverBackgroundColor: '#3491f7',
        pointHoverBorderColor: '#fff',
        pointHoverBorderWidth: 3,
        fill: true,
        tension: 0.4
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: false
      },
      tooltip: {
        backgroundColor: 'rgba(51, 51, 51, 0.95)',
        padding: 12,
        titleColor: '#fff',
        bodyColor: '#fff',
        borderColor: '#3491f7',
        borderWidth: 1,
        displayColors: false,
        callbacks: {
          title: (tooltipItems) => {
            const label = tooltipItems[0].label;
            if (/^\d{4}-\d{2}-\d{2}$/.test(label)) {
              const dayName = new Date(label + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'long' });
              return [label, dayName];
            }
            return label;
          },
          label: (context) => `Downloads: ${context.parsed.y}`
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          color: '#818181',
          font: {
            size: 12
          }
        },
        grid: {
          color: 'rgba(129, 129, 129, 0.1)',
          drawBorder: false
        }
      },
      x: {
        ticks: {
          color: '#818181',
          font: {
            size: 12
          }
        },
        grid: {
          display: false
        }
      }
    },
    animation: {
      duration: 1500,
      easing: 'easeInOutQuart'
    }
  };

  return (
    <div className="chart-container">
      <div className="chart-header">
        <h3>User Downloads</h3>
        <div className="chart-header-controls">
          {onViewChange && (
            <div className="chart-view-toggle">
              {[{ id: 'daily', label: 'D', title: 'Daily' }, { id: 'weekly', label: 'W', title: 'Weekly' }, { id: 'monthly', label: 'M', title: 'Monthly' }].map(view => (
                <label key={view.id} className={`chart-view-option ${viewType === view.id ? 'active' : ''}`} data-tooltip={view.title}>
                  <input
                    type="radio"
                    name="downloadsViewHome"
                    value={view.id}
                    checked={viewType === view.id}
                    onChange={(e) => onViewChange(e.target.value)}
                  />
                  {view.label}
                </label>
              ))}
            </div>
          )}
          <span className="chart-badge">
            {formatCompactNumber(totalDownloads)} downloads
          </span>
        </div>
      </div>
      <div className="chart-wrapper">
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default UserDownloadsChart;
